/* tslint:disable */
/* eslint-disable */
/**
 * Pfa API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Horse,
  HorseBreed,
  HorseColor,
  HorseSearchResponseDto,
  HorseUpdateDto,
  IGVKennungRequest,
} from '../models/index';
import {
    HorseFromJSON,
    HorseToJSON,
    HorseBreedFromJSON,
    HorseBreedToJSON,
    HorseColorFromJSON,
    HorseColorToJSON,
    HorseSearchResponseDtoFromJSON,
    HorseSearchResponseDtoToJSON,
    HorseUpdateDtoFromJSON,
    HorseUpdateDtoToJSON,
    IGVKennungRequestFromJSON,
    IGVKennungRequestToJSON,
} from '../models/index';

export interface ApiHorseIgvkennungPostRequest {
    iGVKennungRequest?: IGVKennungRequest;
}

export interface ApiHorseRegisterIdGetRequest {
    registerId: string;
}

export interface ApiHorseRegisterIdPutRequest {
    registerId: string;
    horseUpdateDto?: HorseUpdateDto;
}

export interface ApiHorseSearchGetRequest {
    q?: string;
    gender?: string;
}

/**
 * 
 */
export class HorseApi extends runtime.BaseAPI {

    /**
     */
    async apiHorseBreedsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HorseBreed>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/breeds`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HorseBreedFromJSON));
    }

    /**
     */
    async apiHorseBreedsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HorseBreed>> {
        const response = await this.apiHorseBreedsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHorseColorsGetRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<HorseColor>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/colors`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(HorseColorFromJSON));
    }

    /**
     */
    async apiHorseColorsGet(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<HorseColor>> {
        const response = await this.apiHorseColorsGetRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHorseIgvkennungPostRaw(requestParameters: ApiHorseIgvkennungPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Horse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/igvkennung`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IGVKennungRequestToJSON(requestParameters['iGVKennungRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HorseFromJSON(jsonValue));
    }

    /**
     */
    async apiHorseIgvkennungPost(requestParameters: ApiHorseIgvkennungPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Horse> {
        const response = await this.apiHorseIgvkennungPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHorseRegisterIdGetRaw(requestParameters: ApiHorseRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Horse>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling apiHorseRegisterIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/{RegisterId}`.replace(`{${"RegisterId"}}`, encodeURIComponent(String(requestParameters['registerId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HorseFromJSON(jsonValue));
    }

    /**
     */
    async apiHorseRegisterIdGet(requestParameters: ApiHorseRegisterIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Horse> {
        const response = await this.apiHorseRegisterIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiHorseRegisterIdPutRaw(requestParameters: ApiHorseRegisterIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['registerId'] == null) {
            throw new runtime.RequiredError(
                'registerId',
                'Required parameter "registerId" was null or undefined when calling apiHorseRegisterIdPut().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/{registerId}`.replace(`{${"registerId"}}`, encodeURIComponent(String(requestParameters['registerId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: HorseUpdateDtoToJSON(requestParameters['horseUpdateDto']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiHorseRegisterIdPut(requestParameters: ApiHorseRegisterIdPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiHorseRegisterIdPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiHorseSearchGetRaw(requestParameters: ApiHorseSearchGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<HorseSearchResponseDto>> {
        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['gender'] != null) {
            queryParameters['gender'] = requestParameters['gender'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-KEY"] = await this.configuration.apiKey("X-API-KEY"); // ApiKey authentication
        }

        const response = await this.request({
            path: `/api/Horse/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => HorseSearchResponseDtoFromJSON(jsonValue));
    }

    /**
     */
    async apiHorseSearchGet(requestParameters: ApiHorseSearchGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<HorseSearchResponseDto> {
        const response = await this.apiHorseSearchGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
